import wix from '../services/wix';

export const getChatSettings = ({ requestId }: { requestId: string }) => {
  return async function(dispatch, getState) {
    const requestName = 'ChatWidget.getChatSettings';
    const responseEventName = `${requestName}Response.${requestId}`;
    try {
      wix.publishToPubSub(responseEventName, {
        success: true,
        results: {
          isSocialChat: getState().socialChatEnabled,
          isBusinessChat: getState().businessChatEnabled,
        },
      });
    } catch (e) {
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
